.SyncSourceHeader {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    padding: 16px 18px;
}

.SyncSourceHeader__logos {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 14px;
}

/* A logo lockup: a 28px mark next to the brand name */
.SyncSourceHeader__logo {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    font-size: 20px;
    line-height: 1;
    letter-spacing: -0.02em;
    white-space: nowrap;

    & img,
    & svg {
        flex: 0 0 auto;
        width: 28px;
        height: 28px;
    }
}

.SyncSourceHeader__soniq {
    font-weight: var(--soniq-t--global--font--weight--bold);
    color: var(--soniq-t--global--text--color--primary--default);
}

/* The round two-way sync mark between the logos */
.SyncSourceHeader__sync {
    display: grid;
    place-items: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid var(--soniq-t--global--border--color--card--default);
    color: var(--soniq-t--global--text--color--label--default);
}

@media (max-width: 760px) {
    .SyncSourceHeader__logos {
        gap: 10px;
    }

    .SyncSourceHeader__logo {
        gap: 6px;
        font-size: 16px;

        & img,
        & svg {
            width: 24px;
            height: 24px;
        }
    }

    .SyncSourceHeader__sync {
        width: 28px;
        height: 28px;
    }
}
